<template>
    <div class="gift-container">
        <div class="gift-tit">
            <div class="title">
                {{ isOldCustomer ? 'V8专享礼品' : '激活成长权益，免费领好礼' }}
            </div>
            <div class="left-con" @click="receiveRecord" v-show="isOldCustomer">
                <span>领取记录</span>
                <img :src="iconArrowRight" alt="" />
            </div>
        </div>
        <div class="gift-desc" v-if="isOldCustomer">
            超值好礼任选
            <span style="color: #ff914e" v-if="isOldCustomer"> 1 </span>项
        </div>
        <div>
            <div class="alert-info" v-show="isShowAlertInfo()">
                <div class="err-icon"></div>
                <span v-html="alertInfoContent()"></span>
            </div>
        </div>
        <div class="gift-list">
            <div class="card" v-for="(item, index) in awardList" :key="index">
                <div class="icon" :style="{ backgroundImage: `url(${item.bigImg[0]})` }"></div>
                <div class="title">
                    {{ awardTitle(item) }}
                </div>
                <div :class="butnStyle(item)" @click="butnClick(item)">{{ awardBtnTxt(item) }}</div>
            </div>
        </div>
        <jdCodePopup
            v-if="showJDPopup"
            :offerNo="offerNo"
            :jd-code-items="jdCodeItems"
            @continueBtn="closeJDPopup"
        />
        <TitleSingleBtnDialog
            :show="showSingleBtnTitleDialog"
            title="领取成功"
            content="实物礼品已领取成功，请耐心等待配送"
            righttxt="知道了"
            @continueBtn="closeSingleDialog"
        />
        <TitleDialog
            :show="showTitleDialog"
            title="已寄送"
            :content="titleContent"
            lefttxt="关闭"
            righttxt="复制单号"
            @giveupBtn="closeTitleDialog"
            @continueBtn="copyOrderId"
        />
        <JDAlertDialog
            :show="showJDAlertDialog"
            title="领取提醒"
            content="京东E卡为虚拟奖品，领取后不退不换，确认是否领取？"
            lefttxt="再看看"
            righttxt="确认领取"
            @giveupBtn="closeJDAlert"
            @continueBtn="confirJD"
        />
        <LogisticsDialog
            :show="showIssuedDialog"
            title="实物礼品发放成功"
            content="实物礼品发放成功后，商品将在7天内寄出。请耐心等待"
            righttxt="知道了"
            @continueBtn="confirmIssuedDialog"
        />
    </div>
</template>
<script>
import iconArrowRight from '@/assets/iconV2.5/mygrade-arrow@2x.png';
import jdCodePopup from '../upgrade/jdCodeDialog.vue';
import minxin from '../../../../common/js/mixin';

export default {
    components: {
        jdCodePopup,
        JDAlertDialog: () => import('../../componets/birthday/homeTitleDialog'),
        TitleDialog: () => import('../../componets/birthday/homeTitleDialog'),
        TitleSingleBtnDialog: () => import('../../componets/birthday/homeSingleBtnTitleDialog'),
        LogisticsDialog: () => import('../../componets/upgrade/LogisticsDialog')
    },
    mixins: [minxin],
    props: ['loanLink'],
    data() {
        return {
            iconArrowRight,
            isOldCustomer: false,
            awardList: null,
            giftInfoCon: null,
            showErrInfo: false,
            showJDPopup: false,
            showSingleBtnTitleDialog: false,
            showTitleDialog: false,
            showJDAlertDialog: false,
            titleContent: '',
            orderId: '',
            currAwardKey: '',
            jdCodeItems: '',
            offerNo: '',
            showIssuedDialog: false,
            maintenceInfo: {}
        };
    },
    created() {
        this.getGiftPackInfo();
        this.setMaintenceInfo();
    },
    methods: {
        isShowAlertInfo() {
            if (this.maintenceInfo && this.maintenceInfo.toast) {
                return true;
            }
            if (this.showErrInfo && this.isOldCustomer) {
                return true;
            }
            return false;
        },
        alertInfoContent() {
            // 升级维护提示
            if (
                this.maintenceInfo &&
                this.maintenceInfo.toast &&
                this.maintenceInfo.priority === 'high'
            ) {
                return this.maintenceInfo.toast;
            }
            // 领取失败提示
            if (this.showErrInfo && this.isOldCustomer) {
                return '礼品发放失败，请重新领取';
            }
            // 疫情发货提示
            if (
                this.maintenceInfo &&
                this.maintenceInfo.toast &&
                this.maintenceInfo.priority === 'low'
            ) {
                return this.maintenceInfo.toast;
            }
            return '';
        },
        receiveRecord() {
            const content = encodeURIComponent(
                JSON.stringify({
                    score: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                    allScore: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                    isOldCustomer: this.giftInfoCon.isOldCustomer
                })
            );
            this.openLink(
                `${window.location.protocol}//growthhome.ppdai.com/collection_record?content=${content}`
            );
        },
        async setMaintenceInfo() {
            this.maintenceInfo = await this.getMaintenceInfo();
        },
        // 实物礼包维护信息下发接口
        getMaintenceInfo() {
            return new Promise(async (res, rej) => {
                const { Result, Content } = await this.$http.maintenceInfo({
                    scene: 'GIFT'
                });
                if (Result === 200) {
                    res(Content);
                } else {
                    res({});
                }
            });
        },
        async getGiftPackInfo() {
            const { Result, Content } = await this.$http.getGiftPackInfo({
                packId: 'giftPackage100y'
            });
            if (Result === 200) {
                this.gethasFailRec();
                this.isOldCustomer = Content.isOldCustomer;
                this.giftInfoCon = Content;
                this.awardList = Content.awardList;
                console.log('getGiftPackInfo', Content);
            }
        },
        async gethasFailRec() {
            const { Result, Content } = await this.$http.hasFailRec({ packId: 'giftPackage100y' });
            if (Result === 200) {
                this.showErrInfo = Content;
            }
            this.awardList.forEach(item => {
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-成长权益-实物礼包',
                    tgt_event_id: 'h5_ACT_privilege_gift',
                    param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                    param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                    param2: item.awardName,
                    param3: item.smallImg,
                    param4: item.awardKey,
                    param5: this.showErrInfo ? '礼品发放失败，请重新领取' : ''
                });
            });
        },
        awardTitle(item) {
            return item.awardName && item.awardName.length > 10
                ? item.awardName.substring(0, 10)
                : item.awardName;
        },
        butnStyle(value) {
            if (!this.giftInfoCon.isOldCustomer || !this.giftInfoCon.isReachedPageScore) {
                // 未达到领取活力值
                return 'butn-boder';
            }
            if (value.awardStatus === 20 && value.status === 1 && value.awardType !== 11) {
                // 当实物为发放中时才是置灰状态
                return 'butn-gray';
            }
            if (this.giftInfoCon.isAllReceived) {
                return value.awardStatus === 20 ? 'butn-hl' : 'butn-gray';
            } else {
                return value.awardStatus === 0 ? 'butn-boder' : 'butn-hl';
            }
        },
        awardBtnTxt(value) {
            if (!this.giftInfoCon.isOldCustomer) {
                return '完成首借解锁';
            }
            if (!this.giftInfoCon.isReachedPageScore) {
                return `还差${this.giftInfoCon.requiredScore - this.giftInfoCon.score}活力值可领取`;
            }
            if (this.giftInfoCon.isAllReceived) {
                if (value.awardStatus === 20) {
                    if (value.awardType === 11) {
                        return '查看卡号';
                    } else {
                        if (value.status === 1) {
                            return '礼品发放中';
                        } else if (value.status === 2) {
                            return value.hasToast ? '查看物流' : '查看领取结果';
                        }
                    }
                } else {
                    return '权益已使用';
                }
            } else if (value.awardStatus === 20) {
                // return value.awardType === 11 ? '查看卡号' : '查看物流';
                if (value.awardType === 11) {
                    return '查看卡号';
                } else {
                    if (value.status === 1) {
                        return '礼品发放中';
                    } else if (value.status === 2) {
                        return value.hasToast ? '查看物流' : '查看领取结果';
                    }
                }
            } else {
                return value.awardStatus === 10
                    ? '立即领取'
                    : `还差${this.giftInfoCon.requiredScore - this.giftInfoCon.score}活力值可领取`;
            }
        },
        async butnClick(item) {
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-成长权益-实物礼包',
                tgt_event_id: 'h5_ACT_privilege_gift',
                param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                param2: this.awardBtnTxt(item),
                param3: item.awardName,
                param4: item.smallImg,
                param5: this.loanLink || '',
                param6: item.awardKey
            });
            if (!this.giftInfoCon.isOldCustomer) {
                this.$emit('OnLoanButnClick');
                return;
            }
            if (!this.giftInfoCon.isReachedPageScore) {
                // 未达到活力值
                this.$emit('OnShowTaskList');
                return;
            }
            if (this.giftInfoCon.isAllReceived) {
                if (item.awardStatus === 20) {
                    // 查看物流弹窗
                    this.orderIdDialog(item);
                } else {
                    this.$toast('您已领取过该权益');
                }
                return;
            } else {
                switch (item.awardStatus) {
                    case 20: {
                        this.orderIdDialog(item);
                        // 物流弹窗
                        break;
                    }
                    case 10: {
                        // 京东卡临时方案
                        item.jdAwardBatchNo = this.awardList.find(
                            i => i.awardType === 5
                        ).awardBatchNo;
                        // 立即领取
                        this.selectedGift = item;
                        if (item.awardType === 11) {
                            this.currAwardKey = item.awardKey;
                            this.showJDAlertDialog = true;
                        } else {
                            const maintenceInfo = await this.getMaintenceInfo();
                            if (this.handleToast(maintenceInfo, item)) {
                                return;
                            }
                            const list = encodeURIComponent(JSON.stringify([item.awardKey]));
                            const content = encodeURIComponent(
                                JSON.stringify({
                                    isOldCustomer: this.giftInfoCon.isOldCustomer,
                                    score: this.giftInfoCon.score,
                                    allScore: this.giftInfoCon.allScore
                                })
                            );
                            const selectedGift = encodeURIComponent(
                                JSON.stringify(this.selectedGift)
                            );
                            this.openLink(
                                `${window.location.protocol}//growthhome.ppdai.com/address?list=${list}&content=${content}&selectedGift=${selectedGift}`
                            );
                        }

                        break;
                    }
                    default:
                        break;
                }
            }
        },
        handleToast(maintenceInfo, item) {
            if (maintenceInfo && maintenceInfo.priority === 'high') {
                this.POINT('h5_auth', {
                    auth_tgt: 'super_privilege_delivery_errorMsg',
                    auth_tgt_name: 'super-成长权益-报错集合',
                    page: 'super-成长权益页',
                    param: maintenceInfo.toast,
                    param1: '/growth/award/maintenceInfo',
                    param3: `${item.awardName}`,
                    param4: `${item.awardKey}`
                });
                if (maintenceInfo.toast) {
                    let toastStr = maintenceInfo.toast.split('>')[1];
                    let toast = toastStr.split('<')[0];
                    this.$toast({
                        message: toast,
                        duration: 2000
                    });
                }
                return true;
            }
        },
        closeSingleDialog() {
            this.showSingleBtnTitleDialog = false;
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-等级权益-实物礼品详情页-物流弹窗',
                tgt_event_id: 'h5_ACT_privilege_gift_logpopup',
                param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                param2: '等待寄送',
                param3: '0',
                param4: '知道了'
            });
        },
        closeTitleDialog() {
            this.showTitleDialog = false;
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-等级权益-实物礼品详情页-物流弹窗',
                tgt_event_id: 'h5_ACT_privilege_gift_logpopup',
                param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                param2: '等待寄送',
                param3: this.orderId,
                param4: '关闭'
            });
        },
        copyOrderId() {
            this.showTitleDialog = false;
            this.POINT('h5_clk', {
                page: 'super-成长权益页',
                tgt_name: 'h5-ACT-等级权益-实物礼品详情页-物流弹窗',
                tgt_event_id: 'h5_ACT_privilege_gift_logpopup',
                param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                param2: '等待寄送',
                param3: this.orderId,
                param4: '复制单号'
            });
            this.$copyText(this.orderId).then(
                e => {
                    this.$toast({
                        message: '复制成功',
                        duration: 2000
                    });
                },
                e => {
                    this.$toast({
                        message: '复制失败',
                        duration: 2000
                    });
                }
            );
        },
        async reportPopup(item) {
            await this.$http.reportPopup({
                offerNo: item.offerNo
            });
        },
        async orderIdDialog(item) {
            if (item.awardType === 11) {
                // 京东卡号弹窗
                this.offerNo = item.offerNo;
                // 京东卡
                const res = await this.$http.queryVcardInfo({ offerNo: this.offerNo });
                if (res.Result !== 200) {
                    this.$toast({
                        message: res.ResultMessage,
                        duration: 2000
                    });
                } else {
                    this.jdCodeItems = res.Content;
                    this.showJDPopup = true;
                }
                return;
            } else {
                // 礼品发放中
                if (item.status === 1) {
                    return;
                }

                // 查看领取结果
                if (item.status === 2 && !item.hasToast) {
                    this.POINT('h5_clk', {
                        tgt_event_id: 'h5_ACT_privilege_gift',
                        tgt_name: 'h5-ACT-成长权益-实物礼包',
                        page: 'super-成长权益页',
                        param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1', // 当前已领取活力值。-1表示未激活
                        param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                        param2: this.awardBtnTxt(item),
                        param3: item.awardName,
                        param4: item.smallImg,
                        param5: this.loanLink || '',
                        param6: item.awardKey
                    });
                    this.currentGift = item;
                    this.showIssuedDialog = true;
                    await this.reportPopup(item);
                    this.getGiftPackInfo();

                    this.POINT('h5_element_imp', {
                        tgt_event_id: 'h5_ACT_privilege_gift_ffbox',
                        page: 'h5-ACT-等级权益-实物礼品',
                        tgt_name: 'h5-ACT-等级权益-实物礼品首页-发放成功弹窗',
                        param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1', // 当前已领取活力值。-1表示未激活
                        param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                        param2: item.awardName,
                        param3: item.awardKey,
                        param4: `实物礼品发放成功`,
                        param5: `实物礼品发放成功后，商品将在7天内寄出。请耐心等待`
                    });
                    return;
                }
            }
            if (item.businessNum) {
                this.showTitleDialog = true;
                this.orderId = item.businessNum;
                this.itemName = item.awardName;
                this.titleContent = `商品已寄出，物流单号:${this.orderId}`;
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-等级权益-实物礼品详情页-物流弹窗',
                    tgt_event_id: 'h5_ACT_privilege_gift_logpopup',
                    param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                    param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                    param2: '已寄送',
                    param3: item.businessNum
                });
            } else {
                this.showSingleBtnTitleDialog = true;
                this.POINT('h5_element_imp', {
                    page: 'super-成长权益页',
                    tgt_name: 'h5-ACT-等级权益-实物礼品详情页-物流弹窗',
                    tgt_event_id: 'h5_ACT_privilege_gift_logpopup',
                    param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : '-1',
                    param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : '-1',
                    param2: '等待寄送',
                    param3: '0'
                });
            }
        },
        closeJDAlert() {
            this.showJDAlertDialog = false;
        },
        confirmIssuedDialog() {
            this.showIssuedDialog = false;
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_privilege_gift_ffbox',
                tgt_name: 'h5-ACT-等级权益-实物礼品首页-发放成功弹窗',
                page: 'h5-ACT-等级权益-实物礼品',
                param: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.score : -1, // 当前已领取活力值。-1表示未激活
                param1: this.giftInfoCon.isOldCustomer ? this.giftInfoCon.allScore : -1,
                param2: this.currentGift.awardName,
                param3: this.currentGift.awardKey,
                param4: `实物礼品发放成功`,
                param5: `实物礼品发放成功后，商品将在7天内寄出。请耐心等待`,
                param6: `知道了`
            });
        },
        confirJD() {
            this.showJDAlertDialog = false;
            const list = encodeURIComponent(JSON.stringify([this.currAwardKey]));
            const content = encodeURIComponent(
                JSON.stringify({
                    isOldCustomer: this.giftInfoCon.isOldCustomer,
                    score: this.giftInfoCon.score,
                    allScore: this.giftInfoCon.allScore
                })
            );
            const selectedGift = encodeURIComponent(JSON.stringify(this.selectedGift));
            this.openLink(
                `${window.location.protocol}//growthhome.ppdai.com/address?list=${list}&content=${content}&selectedGift=${selectedGift}`
            );
        },
        closeJDPopup() {
            this.showJDPopup = false;
        }
    }
};
</script>>
<style lang="less" scoped>
.gift-container {
    padding: 34px 18px 0;

    .gift-tit {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .title {
            font-size: 18px;
            color: #002a3c;
            font-weight: bold;
        }

        .left-con {
            color: #254d5e;
            font-size: 13px;

            img {
                margin-left: 4px;
                width: 6px;
                height: 10px;
            }
        }
    }

    .gift-desc {
        margin-top: 7px;
        color: #002a3c;
        font-size: 13px;
    }

    .alert-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #ff5a5a;
        font-size: 11px;
        margin-top: 8px;

        .err-icon {
            margin-right: 4px;
            width: 14px;
            height: 14px;
            background-size: 100% 100%;
            background-image: url('../../../../assets/images/icon_errer@2x.png');
        }
    }

    .gift-list {
        margin-top: 2px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: space-between;

        .card {
            margin-top: 15px;
            width: 165px;
            height: 213px;
            background: #ffffff;
            box-shadow: 0px 1px 8px 0px rgba(186, 201, 207, 0.32);
            border-radius: 6px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .icon {
                width: 165px;
                height: 145px;
                background-size: 100% 100%;
            }

            .title {
                margin-top: 10px;
                color: #002a3c;
                font-size: 14px;
                font-weight: 500;
            }

            .butn-boder {
                margin-top: 9.9px;
                padding: 0 12px;
                height: 24px;
                border-radius: 13px;
                border: 0.9px solid #ffb03a;
                color: #ffb03a;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
            }

            .butn-hl {
                margin-top: 10px;
                padding: 0 12px;
                height: 24px;
                background: #ff8143;
                border-radius: 13px;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
                color: #fff;
            }

            .butn-gray {
                margin-top: 10px;
                padding: 0 12px;
                height: 24px;
                background: #dce1e6;
                border-radius: 13px;
                font-size: 12px;
                text-align: center;
                line-height: 24px;
                color: #fff;
            }
        }
    }
}
</style>>
